import './jquery';
import 'jquery-ujs';
// import 'bootstrap';
//  import 'accounting';
import accounting from 'accounting';
// import '@gitlab/svgs/dist/icons.svg';

import setConfigs from '@gitlab/ui/dist/config';
import './sentry';

import initNavBar from '~/javascripts/navigation';
import initSignInApp from '~/javascripts/sessions/init_sign_in';
import initSideBar from '~/javascripts/sidebar/init_sidebar';
import initAlerts from '~/javascripts/alerts/init_alerts';
import initBreadcrumbs from '~/javascripts/breadcrumbs/init_breadcrumbs';
import initAlertHandler from '~/javascripts/alert_handler';
import { initTracking } from '~/javascripts/tracking';
import initValidation from '~/javascripts/forms/validation/init_validation';

setConfigs();
initAlertHandler();
initTracking();
initValidation();

accounting.settings.currency.symbol = gon.global?.currency || '¥';

document.addEventListener('DOMContentLoaded', () => {
  initNavBar(document.getElementById('js-navigation'));
  initAlerts();
  initBreadcrumbs();
  initSignInApp();
  initSideBar();
});
